module.exports = __webpack_public_path__ + "img/minus_icon.96e225e7.svg";